<div class="v4-layout-info editing">
  <div class="v4-layout-info-title flex flex-row items-center justify-between">
    <span>{{ "word.other" | translate }}</span>

    @if (!isDirectBooking) {
      <a nz-button nzType="link" nzSize="small" (click)="onRereadReservation()">
        <!-- 重新读取 -->
        {{ "order.read_data_again" | translate }}
      </a>
    }
  </div>

  <div class="v4-layout-fields">
    <!-- 订单号 -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <span>{{ "order.order_code" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <div class="ellipsis">
            {{ orderDetail?.reservation_order?.code }}
          </div>
          <button
            class="ml-2 no-min-width"
            nz-button
            nzSize="small"
            hostClipboard
            [clipboardData]="orderDetail?.reservation_order?.code">
            {{ "word.copy" | translate }}
          </button>
          <button
            class="ml-2 no-min-width"
            nz-button
            nzSize="small"
            (click)="toLogPage('reservation_order', orderDetail?.reservation_order?.code)">
            {{ "system.log" | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- 下单时间 -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <span>{{ "order.booked_time_time" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <span>
            {{
              orderDetail?.booked_time
                ? (orderDetail?.booked_time | dateformat)
                : ("order.can_not_get_book_time" | translate)
            }}
          </span>
        </div>
      </div>
    </div>

    <!-- 取消时间 -->

    <div class="v4-layout-field" *ngIf="orderDetail?.reservation_cancel_time">
      <div class="v4-layout-field-label">
        <span>{{ "order.cancel_time_time" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <span>
            {{ orderDetail?.reservation_cancel_time?.cancel_time }}
          </span>
        </div>
      </div>
    </div>

    <!-- 预订房源 -->
    @if (!isDirectBooking) {
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          <span>{{ "order.order_channel_house" | translate }}</span>
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <div class="flex-1">
              {{ orderDetail?.origin_house_title || orderDetail?.house_title }}
            </div>
            <a
              class="ml-2"
              nz-button
              nzType="link"
              nzSize="small"
              [href]="orderDetail?.origin_house_link"
              target="_blank">
              <!-- 浏览 -->
              {{ "order.scan" | translate }}
            </a>
          </div>
        </div>
      </div>
    }

    <!-- 渠道账号 -->
    <div class="v4-layout-field" *ngIf="orderDetail?.thirdparty_username">
      <div class="v4-layout-field-label">
        <span>{{ "reservation.detail.account.item.title" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <span>{{ orderDetail?.thirdparty_username }}</span>
        </div>
      </div>
    </div>

    <!-- 创建人 -->
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        <span>{{ "reservation.detail.creator.item.title" | translate }}</span>
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          @if (isSubaccount) {
            <span>{{ orderDetail?.creator_name }}</span>
          } @else {
            <nz-select
              class="flex-1"
              [nzPlaceHolder]="'reservation.detail.creator.item.placeholder' | translate"
              [nzOptions]="optionsOfSubaccount"
              [(ngModel)]="creatorId"
              (ngModelChange)="onCreatorChange()">
            </nz-select>
          }
        </div>
      </div>
    </div>

    <!-- 取消此单 -->
    <!--    <div class="v4-layout-field">-->
    <!--      <div class="v4-layout-field-label">-->
    <!--        <a-->
    <!--          class="text-danger hover:text-danger whitespace-nowrap"-->
    <!--          href="javascript:void()"-->
    <!--          (click)="onClickCancelOrder()"-->
    <!--          >{{ "order.cancel_order" | translate }}</a-->
    <!--        >-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</div>
